# EVERY SHELL CATCHES UP AT A ROUTE CHANGE — card 6ab16d75013e5b1a5ad54300.
#
# THE MECHANISM ALREADY EXISTED, IN ONE SHELL. Every response carries
# X-Client-Version; client_version.coffee compares it to the bundle this page
# is running and reloads at a moment when nothing is half-done, once per
# version. The parent app asks at three such moments — after getAccount, between
# questions, and on every route change. The teacher and org/district shells ask
# at exactly one: their boot getAccount.
#
# WHAT THAT COSTS. Their route resolves call refresh() only when needsRefresh()
# says so (loopback_api.coffee: dirty, or thirty minutes since the last load),
# and their transitionService.onSuccess hooks did i18n and nothing else. So a
# teacher with the portal open, or a district admin with a dashboard up on a
# second monitor, kept running whatever bundle they loaded this morning —
# including the crash we shipped a fix for at lunchtime — until they closed the
# tab or happened onto a route that refreshed after half an hour. Owner,
# 2026-09-21: teachers and K-12 admins should get the same push-to-upgrade the
# parent app has, so that when we fix a crash in their code the fix reaches tabs
# already open.
#
# ONE HELPER, THREE CALLERS. The card asked for this rather than three copies,
# and the sign-in rule below is the reason it matters: a rule that has to hold
# in three files is a rule that holds in two of them.
#
# NOT DURING SIGN-IN. Owner, 2026-09-21, on this card: "A reload must never fire
# during the Clever sign-in: a reload while ?code is in flight can resend or
# lose the code and break the OAuth exchange. Keep the new route-change check
# out of the sign-in path... this card is only for a portal left open
# mid-session." Two guards, because a sign-in is two different things:
#
#   THE SCREEN. The `login` state is skipped outright ("forget login"). Nobody
#   is mid-session there, so there is nothing for an upgrade to rescue, and a
#   reload underneath somebody typing a password is pure loss.
#
#   THE EXCHANGE. A `?code=` or `?access_token=` in the address bar is a
#   credential this page is in the middle of spending. app-route.coffee now
#   strips `?code=` before it posts it (card 6ab16a49a4d698cda2b1fab0), which
#   closes the window this guard covers — but only for the one path that
#   remembered to, and only until the next handoff is written. The guard is
#   cheap and it is the difference between a stale tab and a class of children
#   who cannot sign in.
#
# onSuccess, NOT onStart — the parent shell's own comment (app-route.coffee)
# says why and it holds for all three: by the time onSuccess runs the hash is
# the screen the person asked for, so the reload lands THERE. Aborting at
# onStart would reload the screen they were leaving.

import { reloadIfUpdateAvailable } from '../../../../schema/framework/shared/client_version.coffee'

# The one state name all three shells give their sign-in screen
# (ElephantLearning/app-route.coffee, TeacherPortal/app-route.coffee,
# Organization/app-route.coffee all declare `name: 'login'`). `logout` joins it
# for the obvious reason: a session being torn down is not a session to upgrade.
SIGN_IN_STATES = ['login', 'logout']

# A credential in the query string that this page is here to spend.
CREDENTIAL_PARAMS = /[?&](code|access_token)=/

export signInInFlight = (win) ->
  try
    search = "#{win?.location?.search ? ''}"
    href = "#{win?.location?.href ? ''}"
    # `search` is the normal reading; `href` covers a shell whose credential
    # arrived before the hash and a stubbed location that carries only href.
    CREDENTIAL_PARAMS.test(search) or CREDENTIAL_PARAMS.test(href)
  catch e
    false

# Should a transition to `stateName` be allowed to reload this tab?
export upgradeIsSafeHere = (stateName, win) ->
  return false if stateName? and "#{stateName}" in SIGN_IN_STATES
  not signInInFlight win

# Install the route-change safe point on the shell's router
# (router/hash_router.coffee, card 6ac022caa664bc34d57be8c1; its onSuccess hook
# hands over the route that opened). `label` names the shell in the reload's log
# line, which is what tells whoever is reading a crash report's console tail
# which tab reloaded and why.
export installRouteChangeUpgrade = (router, label, deps = {}) ->
  return false unless router?.onSuccess?
  win = deps.window ? (if typeof window != 'undefined' then window else null)
  reload = deps.reload ? reloadIfUpdateAvailable

  router.onSuccess (opened) ->
    name = opened?.name
    return false unless upgradeIsSafeHere name, win
    reload "#{label}: route transition to #{name}", win
  true
